module.exports = __webpack_public_path__ + "static/img/gaozhonglishi9.a3808fdd.jpg";